export default "__VITE_ASSET__e157b8ac__"